import { useContext } from 'react';

import { FeatureFlagContext } from '@/providers/FeatureFlagsProvider';

export function useFeatureFlags() {
  return useContext(FeatureFlagContext);
}
